import React, { useState, useEffect } from "react";

const TimeCountDown = () => {
  // Update this to your target date in June 2025 when you have the exact date
  const [countdownDate] = useState(new Date("06/15/2025").getTime());
  const [state, setState] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setNewTime();
    }, 1000);

    return () => clearInterval(timer); // Clear the interval on component unmount
  }, []);

  const setNewTime = () => {
    const currentTime = new Date().getTime();
    const distanceToDate = countdownDate - currentTime;

    if (distanceToDate >= 0) {
      let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
      let hours = Math.floor(
        (distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor(
        (distanceToDate % (1000 * 60 * 60)) / (1000 * 60)
      );
      let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

      // Format numbers to have leading zeros if needed
      days = days < 10 ? `0${days}` : days;
      hours = hours < 10 ? `0${hours}` : hours;
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      seconds = seconds < 10 ? `0${seconds}` : seconds;

      setState({ days, hours, minutes, seconds });
    } else {
      // Countdown has ended, set all values to zero
      setState({ days: "00", hours: "00", minutes: "00", seconds: "00" });
    }
  };

  return (
    <div className="react-countdown">
      <div className="time-section">
        <div className="time">{state.days}</div>
        <small className="time-text">Days</small>
      </div>
      <div className="time-section">
        <div className="time">{state.hours}</div>
        <small className="time-text">Hours</small>
      </div>
      <div className="time-section">
        <div className="time">{state.minutes}</div>
        <small className="time-text">Min</small>
      </div>
      <div className="time-section">
        <div className="time">{state.seconds}</div>
        <small className="time-text">Sec</small>
      </div>
    </div>
  );
};

export default TimeCountDown;
